export interface GuestVoucherReconciliationComponentProps {
    // No props needed — the reconciliation view is self-contained
}

export const GuestVoucherReconciliationComponent = {
    MountAsync: async (target: HTMLElement, props: GuestVoucherReconciliationComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { GuestVoucherReconciliationComponent } = await import('./GuestVoucherReconciliationComponent');
        return await mountReactComponentAsync(target, GuestVoucherReconciliationComponent, props);
    }
};
